const percentage = (value) => {
  if (typeof value === 'number') {
    const pValue = (value * 100).toString()
    return `${pValue.split('.')[0]}%`
  }
  return value
}

const votePercent = (value, unopposedD, unopposedR, shift) => {
  if (!value && value !== 0) return ''
  let perc = (value * 100).toFixed(1)
  if ((perc > 99 && perc < 100) || (perc === '100.0' && !shift)) {
    perc = '> 99.0'
  } else if ((perc > 0 && perc < 1) || (perc === '0.0' && !shift)) {
    perc = '< 1.0'
  }
  if ((unopposedD === 1 || unopposedR === 1) && shift) {
    perc = '0.0'
  }
  return perc + '%'
}

const money = (value) => {
  value = Math.round(value)
  return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const round = (value, precision = 3) => {
  if (typeof value === 'number') {
    const factor = Math.pow(10, precision)
    return Math.round(value * factor) / factor
  }
  return value
}

// https://stackoverflow.com/a/2901298
const commas = (x) => {
  if (!x) return ''
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const winPerc = (v) => {
  let perc = v
  if (perc > 99) {
    perc = '> ' + 99
  } else if (perc < 1) {
    perc = '< ' + 1
  }
  return perc
}

export default {
  commas,
  money,
  percentage,
  round,
  votePercent,
  winPerc
}



// WEBPACK FOOTER //
// ./src/filters/numbers.js